export type CabinPart =
  | "sleeping-room"
  | "cedar-sauna"
  | "outdoor-bath"
  | "observation-deck";

export interface ItineraryItem {
  time: string;
  title: string;
  description: string;
}

export interface RetreatPackage {
  id: string;
  name: string;
  duration: string;
  occupancy: string;
  price: string;
  inclusions: string[];
}

export interface Hotspot {
  part: CabinPart;
  label: string;
  detail: string;
}

export interface AeraContent {
  brand: { name: string; descriptor: string; promise: string };
  itinerary: ItineraryItem[];
  packages: RetreatPackage[];
  hotspots: Hotspot[];
  testimonial: { quote: string; attribution: string };
  disclosure: string;
  studioUrl: string;
}

export const aeraContent: AeraContent = {
  brand: {
    name: "AERA",
    descriptor: "A private clearing in the North Woods",
    promise: "Leave the noise where the road ends."
  },
  hotspots: [
    {
      part: "sleeping-room",
      label: "The sleeping room",
      detail: "Linen, oak and a single uninterrupted view of the pines."
    },
    {
      part: "cedar-sauna",
      label: "Cedar sauna",
      detail: "Heat drawn slowly from local stone and rain-fed water."
    },
    {
      part: "outdoor-bath",
      label: "Outdoor bath",
      detail: "A private basin open to mist, weather and the night sky."
    },
    {
      part: "observation-deck",
      label: "Observation deck",
      detail: "A west-facing platform for the final light of the day."
    }
  ],
  itinerary: [
    { time: "06:30", title: "Dawn breathwork", description: "Wake with the clearing before the first cup is poured." },
    { time: "08:00", title: "Forest bathing", description: "A silent walk through spruce, moss and cold morning air." },
    { time: "12:30", title: "Seasonal table", description: "Lunch from the kitchen garden and neighbouring farms." },
    { time: "16:00", title: "Cedar heat", description: "Sauna, rain shower and an hour with nowhere else to be." },
    { time: "19:30", title: "Fireside supper", description: "A long table, an open flame and the day's last conversation." },
    { time: "22:00", title: "Night silence", description: "The lights lower. The forest keeps watch." }
  ],
  packages: [
    {
      id: "clearing",
      name: "The Clearing",
      duration: "Two nights",
      occupancy: "Two guests",
      price: "From £780",
      inclusions: ["Private cabin", "Breakfast and supper", "Sauna access"]
    },
    {
      id: "long-exhale",
      name: "The Long Exhale",
      duration: "Three nights",
      occupancy: "Two guests",
      price: "From £1,260",
      inclusions: ["Guided itinerary", "All meals", "Private treatments"]
    },
    {
      id: "aera-private",
      name: "AERA Private",
      duration: "Four nights",
      occupancy: "Up to twelve",
      price: "By arrangement",
      inclusions: ["Complete-site hire", "Private host", "Bespoke programme"]
    }
  ],
  testimonial: {
    quote: "By the second morning, time had stopped behaving like a schedule.",
    attribution: "Mara & Elise · October stay"
  },
  disclosure:
    "AERA is a fictional portfolio experience created by Beyond Static Studio. Packages, availability and testimonials are illustrative.",
  studioUrl: "https://beyondstaticstudio.com"
};
